import { Capacitor } from '@capacitor/core'

// True inside the iOS / Android Capacitor wrap.
export const isNative = Capacitor.isNativePlatform()
export const isIOS = Capacitor.getPlatform() === 'ios'

// The public web origin for any link we hand to someone else (share links,
// invites, QR codes, auth redirects). In the native wrap window.location is
// capacitor://localhost, which is useless to a recipient, so fall back to
// the configured live app URL.
const LIVE_APP_URL = 'https://app.signedandsorted.app'

export function publicOrigin(): string {
  if (typeof window === 'undefined') return LIVE_APP_URL
  if (isNative) return (import.meta.env.VITE_APP_URL || LIVE_APP_URL).replace(/\/$/, '')
  return window.location.origin
}
